<template>
  <button class="text-link" type="button" title="" @click="onClick">
    SAML SSO
  </button>
</template>
<script lang="ts" setup>
import { useNuxtApp } from '#imports';
const { $captureEvent: captureEvent } = useNuxtApp();

const onClick = () => {
  captureEvent('begin_login', {
    method: 'saml_sso',
  });
  window.location.href = 'https://enterprise.mailslurp.com/';
};
</script>
